/**
 * Multi-tenant table resolver
 * Maps company context and base table name to the correct Supabase table
 * 
 * Gilani Mobility uses base tables: requests, g24_requests, diving_solution_requests, turney_seat_requests
 * Gilani Engineering uses suffixed tables: requests_eng, g24_requests_eng, etc.
 */

export const getTableName = (baseTableName, company) => {
  if (company === 'gilani-engineering') {
    return `${baseTableName}_eng`;
  }
  return baseTableName;
};

/**
 * Get company display name
 */
export const getCompanyDisplay = (company) => {
  return company === 'gilani-engineering' ? 'Gilani Engineering' : 'Gilani Mobility';
};

/**
 * Resolve request table from job type
 */
export const resolveRequestTable = (jobType, company = 'gilani-mobility') => {
  let baseTable = 'requests'; // default
  
  if (jobType === 'The Ultimate G24') {
    baseTable = 'g24_requests';
  } else if (jobType === 'Diving Solution Installation') {
    baseTable = 'diving_solution_requests';
  } else if (jobType === 'Turney Seat Installation') {
    baseTable = 'turney_seat_requests';
  }
  
  return getTableName(baseTable, company);
};
